var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "filter-container-content",
          staticStyle: { "margin-top": "0" },
        },
        [
          _c(
            "div",
            { staticClass: "filter-container-new" },
            [
              _c(
                "el-form",
                {
                  ref: "filterForm",
                  attrs: { "label-position": "top", model: _vm.filterForm },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.companyType"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.companyTypeText,
                                  callback: function ($$v) {
                                    _vm.companyTypeText = $$v
                                  },
                                  expression: "companyTypeText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.companyName"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.companyName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "companyName", $$v)
                                  },
                                  expression: "filterForm.companyName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.companyNameEn"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.companyNameEn,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "companyNameEn",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.companyNameEn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("roleCertificationApplication.usci") +
                                  "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.usci,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "usci", $$v)
                                  },
                                  expression: "filterForm.usci",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.companyAbbrev"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.companyAbbrev,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "companyAbbrev",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.companyAbbrev",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.companyAddress"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.companyAddress,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "companyAddress",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.companyAddress",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.country"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.country,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "country", $$v)
                                  },
                                  expression: "filterForm.country",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.province"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.province,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "province", $$v)
                                  },
                                  expression: "filterForm.province",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("roleCertificationApplication.city") +
                                  "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.city,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "city", $$v)
                                  },
                                  expression: "filterForm.city",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.simisCompanyCode"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.simisCompanyCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "simisCompanyCode",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.simisCompanyCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.simisCompanyNameCn"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.simisCompanyNameCn,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "simisCompanyNameCn",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.simisCompanyNameCn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "roleCertificationApplication.simisCompanyNameEn"
                                  ) + "：",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.filterForm.simisCompanyNameEn,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "simisCompanyNameEn",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.simisCompanyNameEn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.filterForm.businessLicenseScanningCopy
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 14 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "flex-item",
                                  attrs: {
                                    label: _vm.$t(
                                      "roleCertificationApplication.businessLicenseScanningCopy"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-paperclip",
                                      },
                                      on: { click: _vm.handleDownload },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.viewLink"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c("el-col", { attrs: { span: 23 } }, [
                        _c(
                          "div",
                          { staticClass: "button-container" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-primary",
                                attrs: {
                                  icon: "el-icon-edit-outline",
                                  type: "primary",
                                },
                                on: { click: _vm.handEditCompanyInfo },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("roleCertificationApplication.add")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-plain-primary",
                                attrs: { icon: "el-icon-refresh-left" },
                                on: { click: _vm.handRefresh },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("btn.refresh")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "container-content-tips" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("roleCertificationApplication.tips")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticClass: "table-container-new" },
          [
            _c(
              "hot-table",
              {
                ref: "hotTable",
                attrs: {
                  "data-source": _vm.tableData,
                  settings: _vm.hotSettings,
                  "current-page": _vm.listQuery.currentPage,
                  "selection-column-title": _vm.$t("home.No"),
                  "page-size": _vm.listQuery.pageSize,
                },
              },
              [
                _c("hot-column", {
                  attrs: {
                    data: "roleCode",
                    title: _vm.$t("roleCertificationApplicationTable.roleCode"),
                    "class-name": "htCenter",
                    "filter-list": _vm.sysRole,
                    renderer: _vm.roleCodeRenderer,
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "officeAbbrev",
                    title: _vm.$t(
                      "roleCertificationApplicationTable.officeAbbrev"
                    ),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "portCode",
                    title: _vm.$t("roleCertificationApplicationTable.portCode"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "jpBookingForwarderNameEn",
                    title: _vm.$t(
                      "roleCertificationApplicationTable.jpBookingForwarderCode"
                    ),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "authStatus",
                      title: _vm.$t(
                        "roleCertificationApplicationTable.authStatus"
                      ),
                      "class-name": "htCenter",
                    },
                  },
                  [_c("indexHotAtt", { attrs: { "hot-renderer": "" } })],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "applyDate",
                    title: _vm.$t(
                      "roleCertificationApplicationTable.applyDate"
                    ),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      title: _vm.$t(
                        "roleCertificationApplicationTable.actions"
                      ),
                      "class-name": "htCenter",
                    },
                  },
                  [
                    _c("indexHotOpt", {
                      attrs: { "hot-renderer": "" },
                      on: {
                        handleSubmit: _vm.handleSubmit,
                        handleViewDetail: _vm.handleViewDetail,
                        handleCancel: _vm.handleCancel,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "pagePanel",
              staticStyle: { "text-align": "right" },
              attrs: {
                total: _vm.total,
                page: _vm.listQuery.currentPage,
                limit: _vm.listQuery.pageSize,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "currentPage", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "pageSize", $event)
                },
                pagination: _vm.searchFn,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("initDetail", {
        ref: "initDetail",
        attrs: {
          "destroy-on-close": true,
          width: "35%",
          details: _vm.selectedRow,
          visible: _vm.initDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.initDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }